export const projectsData = [
  {
    id: 1,
    title: "PFP Editor",
    description: "A comprehensive web application that allows users to add custom frames and effects to their profile pictures with real-time preview.",
    image: "/images/pfp.png",
    tags: ["All", "Html", "React"],
    gitUrl: "https://github.com/coderQoce/Pfp-Changer.git",
    previewUrl: "https://pfp-changer.vercel.app/",
    createdAt: "2024-01-15"
  },
  {
    id: 3,
    title: "Yoruba Homonym System",
    description: "An intelligent linguistic system that helps users search, identify, and understand Yoruba homonyms with detailed explanations.",
    image: "/images/yor.png",
    tags: ["All", "React"],
    gitUrl: "https://github.com/coderQoce/yoruba-homonym-system.git",
    previewUrl: "https://yoruba-orthography.vercel.app/",
    createdAt: "2024-02-01"
  },
  {
    id: 7,
    title: "School Management System",
    description: "A comprehensive online school management platform for administrators, teachers, and students with attendance tracking and grade management.",
    image: "/images/4.png",
    tags: ["All", "React", "Node.JS"],
    gitUrl: "https://github.com/KSwitch1303/school-MS-frontend",
    previewUrl: "https://school-ms-frontend.vercel.app/",
    createdAt: "2023-11-20"
  },
  {
    id: 8,
    title: "Harvest-Nexus Landing Page",
    description: "A modern, responsive landing page for Harvest-Nexus agricultural company showcasing their services and solutions.",
    image: "/images/harvestnexus.jpg",
    tags: ["All", "React"],
    gitUrl: "https://github.com/HarvestNexus/harvest-nexus-landing",
    previewUrl: "https://harvestnexus.vercel.app",
    createdAt: "2024-01-10"
  },
  {
    id: 9,
    title: "Bank Loan Application System",
    description: "A streamlined loan application platform that helps banks process loan applications efficiently with document management.",
    image: "/images/5.png",
    tags: ["All", "React", "Node.JS"],
    gitUrl: "https://github.com/coderQoce/Loan-App.git",
    previewUrl: "https://famfb-loan.vercel.app/",
    createdAt: "2023-12-15"
  },
  {
    id: 10,
    title: "Yoruba to Igbo Translator",
    description: "A bilingual translation tool that helps users translate text between Yoruba and Igbo languages with accuracy.",
    image: "/images/yoruba-to-igbo.jpg",
    tags: ["All", "React", "Node.JS"],
    gitUrl: "https://github.com/coderQoce/yoruba-igbo-translator-joyce",
    previewUrl: "https://yoruba-igbo-translator.netlify.app",
    createdAt: "2024-02-10"
  },
  {
    id: 11,
    title: "Caremeal Nutrition Platform",
    description: "A comprehensive nutrition and meal planning website that provides personalized meal recommendations and nutritional information.",
    image: "/images/Caremeal.jpg",
    tags: ["All", "React"],
    gitUrl: "https://github.com/coderQoce/CareMeal",
    previewUrl: "https://caremeal.netlify.app/",
    createdAt: "2024-01-25"
  },
  {
    id: 12,
    title: "Igbo Homonym Finder",
    description: "A specialized linguistic tool for finding and understanding Igbo homonyms with contextual examples and explanations.",
    image: "/images/homo.jpg",
    tags: ["All", "Python"],
    gitUrl: "https://github.com/coderQoce/igbo-Homo.git",
    previewUrl: "https://igbo-homonym-finder.vercel.app",
    createdAt: "2023-10-15"
  },
  {
    id: 13,
    title: "Perfect-Pretend Event Platform",
    description: "An elegant event website designed for a fictional wedding celebration with RSVP functionality and event details.",
    image: "/images/perfect-pretence.png",
    tags: ["All", "React"],
    gitUrl: "https://github.com/coderQoce/Perfect-Pretence.git",
    previewUrl: "https://perfect-pretence.netlify.app/",
    createdAt: "2024-01-05"
  },
  {
    id: 14,
    title: "BMW Exclusive Dealership",
    description: "A premium automotive website for BMW car sales with inventory management and online booking features.",
    image: "/images/bmw.png",
    tags: ["All", "Html"],
    gitUrl: "https://github.com/coderQoce/onyxAutos.git",
    previewUrl: "https://onyx-autos.vercel.app/",
    createdAt: "2023-11-30"
  },
  {
    id: 15,
    title: "Luxe-by-Mo Hair Boutique",
    description: "An e-commerce platform for premium human hair products and wigs with shopping cart and payment integration.",
    image: "/images/luxe.png",
    tags: ["All", "React"],
    gitUrl: "https://github.com/coderQoce/luxe-strand-by-mo-website.git",
    previewUrl: "https://luxe-hair-boutique.vercel.app/",
    createdAt: "2024-02-20"
  },
  {
    id: 16,
    title: "Catena Labs Handbook",
    description: "A comprehensive technical documentation and handbook website for Catena Labs blockchain development resources.",
    image: "/images/catena.png",
    tags: ["All", "Html"],
    gitUrl: "https://github.com/coderQoce/Catena-Handbook.git",
    previewUrl: "https://www.catenahandbook.tech",
    createdAt: "2024-01-20"
  },
  {
    id: 17,
    title: "Degen NFT Handbook",
    description: "A complete handbook resource for NFT enthusiasts and degen traders with market insights and strategies.",
    image: "/images/degen.png",
    tags: ["All", "Html"],
    gitUrl: "https://github.com/coderQoce/Degen-NFT.git",
    previewUrl: "https://degen-nft.vercel.app/",
    createdAt: "2024-02-05"
  },
  {
    id: 18,
    title: "Degen PFP Generator",
    description: "A creative tool for generating and customizing degen-style profile pictures with various effects and accessories.",
    image: "/images/degenpfp.png",
    tags: ["All", "Html"],
    gitUrl: "https://github.com/coderQoce/NFT.git",
    previewUrl: "https://nft-q6t2.vercel.app/",
    createdAt: "2024-01-30"
  },
  {
    id: 19,
    title: "Greb Pure Water Factory",
    description: "A professional website for Greb Pure Water Factory showcasing their products, services, and company information.",
    image: "/images/greb.png",
    tags: ["All", "React"],
    gitUrl: "https://github.com/coderQoce/GrebWaterFactory-Web.git",
    previewUrl: "https://www.grebwater.com/",
    createdAt: "2024-02-15"
  },
  {
    id: 20,
    title: "Monad Ecosystem Hub",
    description: "A comprehensive website showcasing the Monad blockchain project's ecosystem, partnerships, and technical capabilities.",
    image: "/images/monad.png",
    tags: ["All", "React"],
    gitUrl: "https://github.com/coderQoce/MonadLandingPage",
    previewUrl: "https://monad-landing-page.vercel.app/",
    createdAt: "2024-02-25"
  },
  {
    id: 21,
    title: "ChatRoom Real-time Chat",
    description: "A feature-rich real-time chat application built with React frontend and PHP Laravel backend with WebSocket support.",
    image: "/images/chatbox.png",
    tags: ["All", "React", "PHP"],
    gitUrl: "https://github.com/coderQoce/ChatRooM.git",
    previewUrl: "https://chatroom-app.vercel.app/",
    createdAt: "2024-03-01"
  }
];

export const availableTags = ["All", "React", "Node.JS", "Python", "Html", "PHP"];
